<template>
  <div>
    <v-layout>
      <v-text-field :label="etiket" @blur="deneme()" :placeholder="hatamesaji"  append-icon="search" @click:append="dialogac()"  :tabindex="tabdeger" v-model="val.havayolukodu" mask="NNN" hide-details=""></v-text-field>
    </v-layout>

    <v-dialog scrollable="" v-model="dialog" max-width="550px">
      <v-card color="grey lighten-2">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text"> {{$t('Airline-List')}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field solo hide-details v-model="secilendeger" :label="$t('Please-least-3-digits')" append-icon="search"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions class="elevation-1">
                <v-progress-linear slot="progress"  indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item.HavaYoluKodu)" item>
                    <td class="text-xs-left">{{ props.item.HavaYoluKodu }}</td>
                    <td class="text-xs-left">{{ props.item.HavaYoluAdi }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{$t("cancel_button")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'

  export default {
    props: ["value", "tabdeger", "etiket"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    methods: {
      deneme() {
        if (this.val.havayolukodu != null) {

          var params1 = {
            Code: escape(this.val.havayolukodu),
          }
          this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineGet', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (response.body.HavaYoluKodu != null) {
            this.val.formno = response.body.FormNo
            this.hatamesaji = null
            } else {
              this.val.formno = null
              this.val.havayolukodu = null
              this.hatamesaji = 'Hatalı Kod...'
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-havayollari'
              this.snackbar = true
              this.progress = false

            } else {
              this.text1 = 'Service Unavailable-havayollari'
              this.snackbar = true
              this.progress = false
            }
          })


        }
      },
      kayitgetir: kayitgetir,
      dialogac: dialogac,
      kabul: kabul
    },
    data() {
      return {
        headersservis: [{
            text: this.$t('Code'),
            value: 'HavaYoluKodu'
          },
          {
            text: this.$t('Description'),
            value: 'HavaYoluAdi'
          }

        ],
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,
        hatamesaji:null,
        hatagoster:false,

        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },
    watch: {
      secilendeger(val) {
        val && this.kayitgetir(val)
      }

    },
  }

  function kabul(m) {
    this.hatamesaji = null
    this.val.havayolukodu = String(m)
    var tumliste = []
    tumliste = this.items
    tumliste.forEach(element => {
      if (element.HavaYoluKodu == m) {
        this.val.formno = element.FormNo
      }
    });
    this.dialog = false
  }

  function dialogac() {
    this.dialog = true
  }

  function beforeMount() {

  }

  function kayitgetir(y) {

    if (y != null) {

      if (y.length > 2) {
        this.progress = true
        var params1 = {
          Search: escape(y),
        }
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineSearch', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-havayollari'
            this.snackbar = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable-havayollari'
            this.snackbar = true
            this.progress = false
          }
        })
      } else {
        this.items = []
        this.progress = false
      }

    }
  }
</script>